import { useEffect, useState } from 'react';

import type { WindowDimensions } from './types';

const INITIAL_DIMENSIONS: WindowDimensions = {
  windowHeight: 0,
  windowWidth: 0,
};

const readWindowDimensions = (): WindowDimensions => ({
  windowHeight: window.innerHeight,
  windowWidth: window.innerWidth,
});

export function useFrozenScreenDimensions(): WindowDimensions {
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>(INITIAL_DIMENSIONS);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    setWindowDimensions(readWindowDimensions());
  }, []);
  return windowDimensions;
}
